<template>
	<div class="modal-column">
		<div class="modal-column-full-body">
			<Form mode="block" :rules="{}">
				<div class="inline-form-item">
					<FormItem label="模板名称" required prop="name">
						<Input v-model="formData.title"/>
					</FormItem>
					<FormItem label="凭证字">
						<Select v-model="formData.voucherWord" :datas="voucherWordList" :deletable="false"/>
					</FormItem>
				</div>
				<FormItem label="凭证项">
					<vxe-table height="300" ref="itemsTable" :data="items" border :edit-config="{trigger:'click',mode:'row'}" :edit-rules="validConfig">
						<vxe-column width="80" align="center">
							<template #default="{row,rowIndex}">
								<span @click="pushItem(row)" class="fa fa-plus mr-16px text-hover"/>
								<span @click="popItem(row)" class="fa fa-minus red-color text-hover"/>
							</template>
						</vxe-column>
            <vxe-column field="subjectTitle" title="科目" :edit-render="{}">
<!--              <template #default="{ row }">-->
<!--                <span>{{ formatDept(row.departmentId) }}</span>-->
<!--              </template>-->
              <template #edit="{ row }">
                <vxe-select v-model="row.subjectId" type="text" :options="subjectList" @change="subjectChange($event,row)" filterable transfer></vxe-select>
              </template>
            </vxe-column>
						<vxe-column width="100" field="direction" title="方向" :edit-render="{name:'$select',options:[{label:'借',value:'借'},{label:'贷',value:'贷'}]}"/>
            <vxe-column width="140" field="valueFieldName" title="取值" :edit-render="{}">
              <template #edit="{ row }">
                <vxe-select v-model="row.valueFieldName" type="text" transfer @change="valueFieldChange($event,row)"> 
                  <vxe-option v-for="field in valueFieldList" :key="field.value" :value="field" :label="field.label"></vxe-option>
                </vxe-select>
              </template>
            </vxe-column>
            <vxe-column width="140" field="departmentId" title="部门" :edit-render="{}">
              <template #default="{ row }">
                <span>{{ formatDept(row.departmentId) }}</span>
              </template>
              <template #edit="{ row }">
                <vxe-select v-model="row.departmentId" type="text" :options="deptList" transfer></vxe-select>
              </template>
            </vxe-column>
					</vxe-table>
				</FormItem>
			</Form>
		</div>
		<div class="modal-column-between">
			<vxe-button :loading="loading" @click="$emit('close')" icon="fa fa-close">取消</vxe-button>
			<vxe-button :loading="loading" :disabled="!formData.title" @click="doSubmit()" status="primary" icon="fa fa-check">保存</vxe-button>
		</div>
	</div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
	name: "SalaryVoucherTemplateForm"
}
</script>

<script setup>
import {reactive, ref, toRefs} from "vue";
import setting from "@/api/setting";
import SalaryManage from "../../api/SalaryManage";
import InsuredConfig from "../../api/InsuredConfig";

const emits = defineEmits(['close', 'success']);
const props = defineProps(['type', 'entity']);
const {type, entity} = toRefs(props);
const loading = ref(false)
const itemsTable = ref(null)
const formData = reactive(entity.value ? entity.value : {
	id: null,
	title: null,
	invoiceType: type.value,
	voucherWord: null,
	items: []
})

const validConfig = reactive({
	subjectCode: [{required: true, message: "请选择科目"}]
});

const subjectList = ref([]);
const subjectMap = reactive({});
setting.subject.voucherSelect({all: false}).then(({data}) => {
  subjectList.value = data.map(val => {
    subjectMap[val.id] = val.fullName;
    return {
      value: val.id,
      label: val.code + "-" + val.fullName,
    }
  })
})

const items = reactive(entity.value && entity.value.items && entity.value.items.length > 0 ? entity.value.items : [
	{subjectId:null,subjectCode: null, subjectTitle: null, direction: '借', valueFieldId:null,valueFieldCol: "taxAmountExcluded",valueFieldType:""},
	{subjectId:null,subjectCode: null, subjectTitle: null, direction: '贷', valueFieldId:null,valueFieldCol: "taxAmountExcluded",valueFieldType:""}
])

const subjectChange = (event,row) =>{
  let subjectId = event.value;
  row.subjectTitle = subjectMap[subjectId]

}

const doSubmit = () => {
	itemsTable.value.fullValidate(true, () => {
		let {fullData} = itemsTable.value.getTableData();
    let params = Object.assign({}, formData, {items: fullData});
    // console.log("表单",assign)
    loading.value = true;
    SalaryManage.saveSalaryTemplate(params).then(() => {
			emits('success')
		}).finally(() => loading.value = false)
  })
}

const pushItem = (row) => {
	itemsTable.value.insertAt({subjectCode: null, subjectTitle: null, direction: '借', valueField: "taxAmountExcluded"}, row);
}

const popItem = (row) => {
	let {fullData} = itemsTable.value.getTableData();
	if (fullData.length > 2) {
		itemsTable.value.remove(row);
	}
}

const voucherWordList = ref([]);
setting.voucherWord.list().then(({data}) => {
	formData.voucherWord = data[0].id;
	voucherWordList.value = data.map(val => {
		return {
			key: val.id,
			title: val.word,
		}
	})
})




const deptList = ref([]);
const initDept = () => {
  //初始化部门
  setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT', 'VENDOR']).then(({data}) => {
    deptList.value = data['DEPARTMENT'].map(val => {
      return {
        id: val.id,
        key: val.id,
        value:val.id,
        accountingCategoryId: val.categoryId,
        label: val.name
      }
    });
  })
}

//初始化取值列表
const valueFieldList = ref([]);
const initValueField = async () =>{

  valueFieldList.value.push({valueFieldId:1,valueFieldCol:'totalAmount',valueFieldType:'SALARY',valueFieldName:"工资总额",label:"工资总额",value:1})
  valueFieldList.value.push({valueFieldId:2,valueFieldCol:'deductAmount',valueFieldType:'SALARY',valueFieldName:"应扣工资",label:"应扣工资",value:2})
  valueFieldList.value.push({valueFieldId:3,valueFieldCol:'payableAmount',valueFieldType:'SALARY',valueFieldName:"应发工资",label:"应发工资",value:3})
  valueFieldList.value.push({valueFieldId:4,valueFieldCol:'withholdingAmount',valueFieldType:'SALARY',valueFieldName:"代扣个人款项",label:"代扣个人款项",value:4})
  valueFieldList.value.push({valueFieldId:5,valueFieldCol:'otherDeductAmount',valueFieldType:'SALARY',valueFieldName:"其他扣除",label:"其他扣除",value:5})
  valueFieldList.value.push({valueFieldId:6,valueFieldCol:'exemptionTaxAmount',valueFieldType:'SALARY',valueFieldName:"免征税额",label:"免征税额",value:6})
  valueFieldList.value.push({valueFieldId:7,valueFieldCol:'payableTaxAmount',valueFieldType:'SALARY',valueFieldName:"本月应缴个税",label:"本月应缴个税",value:7})
  valueFieldList.value.push({valueFieldId:8,valueFieldCol:'realPayAmount',valueFieldType:'SALARY',valueFieldName:"实发金额",label:"实发金额",value:8})
  valueFieldList.value.push({valueFieldId:9,valueFieldCol:'enterpriseAmount',valueFieldType:'SALARY',valueFieldName:"公司承担金额",label:"公司承担金额",value:9})
  valueFieldList.value.push({valueFieldId:10,valueFieldCol:'incomeSum',valueFieldType:'SALARY',valueFieldName:"累计收入",label:"累计收入",value:10})
  valueFieldList.value.push({valueFieldId:11,valueFieldCol:'deductSum',valueFieldType:'SALARY',valueFieldName:"累计减除费用",label:"累计减除费用",value:11})
  valueFieldList.value.push({valueFieldId:12,valueFieldCol:'withholdingSum',valueFieldType:'SALARY',valueFieldName:"累计代扣额",label:"累计代扣额",value:12})
  valueFieldList.value.push({valueFieldId:13,valueFieldCol:'payableTaxSum',valueFieldType:'SALARY',valueFieldName:"累计应缴个税",label:"累计应缴个税",value:13})
  valueFieldList.value.push({valueFieldId:14,valueFieldCol:'paidTaxSum',valueFieldType:'SALARY',valueFieldName:"累计已缴个税",label:"累计已缴个税",value:14})
  valueFieldList.value.push({valueFieldId:15,valueFieldCol:'specialChildEdu',valueFieldType:'SALARY',valueFieldName:"子女教育",label:"子女教育",value:15})
  valueFieldList.value.push({valueFieldId:16,valueFieldCol:'specialParent',valueFieldType:'SALARY',valueFieldName:"赡养老人",label:"赡养老人",value:16})
  valueFieldList.value.push({valueFieldId:17,valueFieldCol:'specialHouseLoans',valueFieldType:'SALARY',valueFieldName:"住房贷款",label:"住房贷款",value:17})
  valueFieldList.value.push({valueFieldId:18,valueFieldCol:'specialHouseRent',valueFieldType:'SALARY',valueFieldName:"住房租金",label:"住房租金",value:18})
  valueFieldList.value.push({valueFieldId:19,valueFieldCol:'specialContinuingEdu',valueFieldType:'SALARY',valueFieldName:"继续教育",label:"继续教育",value:19})
  valueFieldList.value.push({valueFieldId:20,valueFieldCol:'specialInfantCare',valueFieldType:'SALARY',valueFieldName:"3岁以下婴幼儿照护",label:"3岁以下婴幼儿照护",value:20})
  valueFieldList.value.push({valueFieldId:21,valueFieldCol:'specialSerious',valueFieldType:'SALARY',valueFieldName:"大病医疗",label:"大病医疗",value:21})
  valueFieldList.value.push({valueFieldId:22,valueFieldCol:'specialSubTotal',valueFieldType:'SALARY',valueFieldName:"专项附加扣除小计",label:"专项附加扣除小计",value:22})
  valueFieldList.value.push({valueFieldId:23,valueFieldCol:'specialSum',valueFieldType:'SALARY',valueFieldName:"累计专项附加扣除",label:"累计专项附加扣除",value:23})
  valueFieldList.value.push({valueFieldId:24,valueFieldCol:'otherDeductSum',valueFieldType:'SALARY',valueFieldName:"累计其他扣除",label:"累计其他扣除",value:24})

  //查询自定义列
  await SalaryManage.listSalaryFields().then(({data}) => {
    // this.forms.configList = data;
    if (data && data.length>0) {
      data.forEach(field=>{
        valueFieldList.value.push({valueFieldId:field.id,valueFieldCol:'fieldValue',valueFieldType:'CUSTOM',valueFieldName:field.fieldName,label:field.fieldName,value:field.id})
      });
    }
  })

  await InsuredConfig.list().then((res) => {
    if (res.data && res.data.length>0) {
      res.data.forEach(social=>{
        valueFieldList.value.push({valueFieldId:social.id,valueFieldCol:'amount',valueFieldType:'SOCIAL_PERSONAL',valueFieldName:"个人 "+social.name,label:"个人 "+social.name,value:social.id+'SOCIAL_PERSONAL'})
        valueFieldList.value.push({valueFieldId:social.id,valueFieldCol:'amount',valueFieldType:'SOCIAL_ENTERPRISE',valueFieldName:"公司 " +social.name ,label:"公司 " +social.name ,value:social.id+'SOCIAL_ENTERPRISE'})
      })
    }
  })
}
initValueField();
const valueFieldChange = (event,row)=>{
  let field = event.value;
  // console.log("field",field)
  row.valueFieldId = field.valueFieldId;
  row.valueFieldCol = field.valueFieldCol;
  row.valueFieldType = field.valueFieldType;
  row.valueFieldName = field.valueFieldName;
}

const wordChange = (event,row)=>{

}
const formatDept = (deptId) =>{
  if (!deptList.value || deptList.value.length==0) return "";
  let find = deptList.value.find(dept=>dept.id==deptId);
  if (find) {
    return find.label;
  }
  return ""
}
initDept();
</script>
